<template>
<vx-card>
    <vs-tabs alignment="fixed">
        <vs-tab label="MIS LIBROS AZ" class="pt-8">
            <div class="vx-row mb-5">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-1/2 md:w-1/4 xl:w-1/4 mt-3 mn-3" style="min-width: 220px;" v-for="(item,$index) in libros_area" :key="$index.id">
                        <div class="text-center caja-libro" style="cursor: pointer; min-height: 350px; border: solid 1px #e5e5e5;" @click="irDesgloseLibro(item)">
                            <div slot="no-body">
                                <div v-if="item.weblibro">
                                    <!-- <img class="responsive card-img-top book" src="https://files.azenequipo.com.ec/libros/image-no-found.jpg" alt="Libro digital AZ"> -->
                                    <img v-if="item.weblibro.length > 3" class="responsive card-img-top book" v-bind:src="$data_book+'websinguia/'+item.weblibro+'/'+item.portada" alt="Libro digital AZ">
                                    <img v-else class="responsive card-img-top" src="https://files.azenequipo.com.ec/libros/image-no-found.jpg" alt="Libro digital AZ">
                                </div>
                                <div v-else>
                                    <img class="responsive card-img-top" style="height: 250px;" src="https://files.azenequipo.com.ec/libros/image-no-found.jpg" alt="Libro digital AZ">
                                </div>
                            </div>
                            <div class="mt-4">
                                <p class="font-bold">{{item.nombrelibro}} </p>
                                <small> {{item.descripcionlibro}} </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vs-tab>
    </vs-tabs>
</vx-card>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import 'vue-select/dist/vue-select.css';
Vue.use(axios)
export default {
    data() {
        return {
            activePrompt: false,
            activePrompt2: false,
            val: '',
            idlibro: '',
            valMultipe: {
                value1: '',
                value2: ''
            },
            select: [],
            libros: [],
            usuario: [],
            asignaturas_docente: [],
            variable_ejemplo: [],
            idasignatura_doc: '',
            series: [],
            areas: [],
            libros_area: [],
            colores: ['#E74C3C', '#8E44AD', '#3498DB', '#16A085', '#F7DC6F', '#E67E22', '#5D6D7E', '#273746'],
            serie_selected: '',
            area_selected: '',
            areas_activo: 1,
            existsImage: false,
        }
    },
    computed: {
        validName() {
            return (this.valMultipe.value1.length > 0 && this.valMultipe.value2.length > 0)
        }
    },
    created() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted() {
        this.getLibros();
    },
    methods: {
        irDesgloseLibro(item) {
            let me = this
            localStorage.datoUser = localStorage.getItem("usuario");
            localStorage.idlibro = item.idlibro
            localStorage.nombreasignatura = item.nombrelibro
            localStorage.yearBook = item.year
            localStorage.tipo_asignatura = "prolipa"; //asignaturas de prolipa
            me.$router.push('/docente/libro/detallelibro')
        },
        irCursosAsigDoc(item) {
            let me = this
            localStorage.idlibro = item.idlibro
            localStorage.idasignatura = item.idasignatura
            localStorage.nombreasignatura = item.nombreasignatura
            localStorage.tipo_asignatura = "docente"; //asignaturas creadas por el docente
            me.$router.push('/docente/cursos_asig_docente')
        },
        async getLibros() {
            let me = this;
            me.libros_area = []
            let region = localStorage.region
            me.$vs.loading();
            await this.$http.get(this.$server_url + 'getLibrosDocentes/' + me.usuario.idusuario + '/' + region + '/' + localStorage.periodo_id)
                .then(function (res) {
                    me.$vs.loading.close();
                    let datos = res.data
                    me.setearValores(datos)
                })
        },
        setearValores(datos) {
            let me = this;
            datos.forEach(element => {
                // var url = me.$data_book+element.weblibro+'/'+element.portada
                var cal = new Object();
                cal.idlibro = element.idlibro
                cal.nombrelibro = element.nombrelibro
                cal.descripcionlibro = element.descripcionlibro
                cal.weblibro = element.weblibro
                cal.pdfconguia = element.pdfconguia
                cal.pdfsinguia = element.pdfsinguia
                cal.guiadidactica = element.guiadidactica
                cal.portada = element.portada
                cal.portada_respuesta = element.portada_respuesta
                cal.year = element.year
                me.libros_area.push(cal)
            });
        },
    },
}
</script>

<style lang="css" scoped>
.caja-libro {
    border: 1px solid #e7e7e7;
}
.book{
    transition: 0.4s;
}
.book:hover {
    cursor: pointer;
    transform: rotateY(-28deg) rotateZ(-2deg) scale(1.02);
    -webkit-backface-visibility: hidden;
    box-shadow: 1px 3px 2px #853554, 20px 8px 0 #c45278;
    margin-top: -10px;
    /* transform: scale(1.02); */
    transition: 0.4s;
}
</style>
